module.exports = __webpack_public_path__ + "img/architecture_card.a24c7c1c.jpg";